import { useCurrentUser } from '@entities/user/model/hooks/use-current-user'
import { Avatar, Flex } from 'antd'

export const ProfileMobileHeader = () => {
    const { user } = useCurrentUser()
    const userName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`
    const validName = userName.length > 15 ? `${userName.slice(0, 15)}...` : userName

    return (
        <div style={{ position: 'sticky', top: 0, zIndex: 100 }}>
            <Flex
                style={{
                    backgroundColor: 'white',
                    padding: '10px 17px',
                    height: 62,
                    borderBottom: '0.5px solid rgba(211, 211, 213, 0.7)'
                }}
                align={'center'}
                justify={'space-between'}
            >
                <Avatar src={user?.photoUrl} size={40}></Avatar>
                <span style={{ color: '#021728', fontSize: 24 }}>{validName}</span>
                <div />
            </Flex>
        </div>
    )
}
